import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy, Timestamp } from "firebase/firestore";
import banner_default from '../assets/banner_default.jpg';
import logo_default from '../assets/logo_default.jpg';
import Loadingimg from "../components_root/loadingimg.jsx";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext.jsx";
import { MdCall, MdAccountCircle, MdLanguage, MdOutlineLocationOn, MdPrint, MdSave, MdSaveAs, MdCancel, MdClose, MdArrowBackIos, MdOutlinePayment, MdOutlinePayments, MdOutlineAccountBox, MdOutlineLocalPrintshop, MdCalendarToday, MdCalendarViewDay, MdCalendarMonth, MdReceipt, MdOutlineReceiptLong, MdFileUpload, MdAddAPhoto, MdOutlineAddAPhoto, MdCalculate } from "react-icons/md";
import { Randomcode } from "../components_root/rendom_code.js";
import CountryCodeSelect from "../body_root/CountryCodeSelect.js";
import "./voucher_print.css";
import AmountToWords from "../components_root/AmountToWords.js";
import { Save_voucher_print } from "../accounting_root/print_root/save_voucher_print.js";
import { Randomnumber } from "../components_root/rendom_number.js";
import Print_receipt_order from "../accounting_root/print_root/print_receipt_order.js";
import Print_receipt_a4 from "../accounting_root/print_root/print_receipt_a4.js";
import Settingprint_popup from "../accounting_root/print_setting_root/settingprint_popup.jsx";
import Select_on_off from "../components_root/select_on_off.jsx";
import Select_yes_no from "../components_root/select_yes_no.jsx";
import Upload_file_popup from "./upload_file_popup.jsx";
import Calculatepopup from "./calculate_popup.jsx";

export const seo = {
    title: "aooz Services | Free & Premium Online Tools...",
    description: "Discover aooz's free and premium online services...",
    keywords: "aooz services, free online tools...",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

export default function Voucher_print() {
    const navigate = useNavigate();
    const { Toastshow } = Toast();
    const servicetablename = "accountingfinancedb";
    const [voucherid, setVoucherid] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [saveloading, setSaveloading] = useState(false);

    const [isLoading_banner, setIsLoading_banner] = useState(true);
    const [IsLoading2, setIsLoading2] = useState(false);
    const [companyData, setCompanyData] = useState([]);
    const [uid, setUid] = useState("");
    const [old_file_uid, setOld_file_uid] = useState("");
    const [old_banner_file_uid, setOld_banner_file_uid] = useState("");
    const [logoUrl, setLogoUrl] = useState("");
    const [BannerUrl, setBannerUrl] = useState("");
    const [refer_number, setRefer_number] = useState("");
    const [remarks, setRemarks] = useState("");
    const [amount, setAmount] = useState();
    const [totalamount, setTotalamount] = useState();
    const [chargetotal, setChargetotal] = useState(0);
    const [voucherprintid, setVoucherprintid] = useState(Randomcode(18));
    const [vouchernumber, setvouchernumber] = useState(Randomnumber(10));
    const [cashierno, setCashierno] = useState();
    const [code, setCode] = useState("+91");

    const [print, setPrint] = useState(true);
    const [mobile, setMobile] = useState("");
    const [namepaying, setNamepaying] = useState("");
    const [addresspaying, setAddresspaying] = useState("");
    const [agreebox, setAgreebox] = useState(true);
    const [payment_method_online, setPayment_method_online] = useState(false);
    const [manage_ledger_accountsdata, setManage_ledger_accountsdata] = useState([]);
    const [mobilestatus, setMobilestatus] = useState(true);
    const [paymentstatus, setPaymentstatus] = useState(false);
    const [voucherdate, setVoucherdate] = useState();
    const [voucher_file_manager_data, setVoucher_file_manager_data] = useState([]);
    const [eventdate, setEventdate] = useState();
    const [eventstatus, setEventstatus] = useState(false);
    const [settingprintopen, setSettingprintopen] = useState(false);
    const [doPrint, setDoPrint] = useState(false);
    const [printpage, setPrintpage] = useState("receipt");
    const [printapply, setPrintapply] = useState("");
    const [printid, setPrintid] = useState("");
    const [select_company_uid, setSelect_company_uid] = useState(null);
    const [guid, setGuid] = useState(null);
    const [vouchersdata, setVouchersdata] = useState([]);
    const [stockstatus, setstockstatus] = useState(false);
    //Calculatepopup
    const [calculateopen, setCalculateopen] = useState(false);
    // file mange
    const [uploadfileopen, setuploadfileopen] = useState(false);
    const [uploadfiledata, setuploadfiledata] = useState("");
    const set_uploadfile = () => {

        setuploadfileopen(prev => !prev);

    };

    // file manager state
    const [filemanager, setfilemanager] = useState({});
    const handleRowChange = (title, rowId, field, value) => {
        setfilemanager(prev => ({
            ...prev,
            [rowId]: {
                title,               // ✅ store title
                ...prev[rowId],      // keep existing fields
                [field]: value       // update current field
            }
        }));
    };

    //
    const [voucher_file_stock_qty_data, setVoucher_file_stock_qty_data] = useState([]);
    useEffect(() => {
        setGuid(Cookies.get("guid"));

    }, []);
    useEffect(() => {
        if (mobilestatus === false) {
            setMobile("0000000000");
            setNamepaying("Not Specified");
        } else {
        }
    }, [mobilestatus]);
    useEffect(() => {
        setSelect_company_uid(Cookies.get("select_company_uid"));
    }, []);
    useEffect(() => {
        const updateDates = () => {
            setVoucherdate(new Date().toLocaleString());
        };
        // run once immediately
        updateDates();
        // run every 10 seconds
        const intervalId = setInterval(updateDates, 1000);
        // cleanup on component unmount
        return () => clearInterval(intervalId);
    }, []);
    const fetchvouchers = async (voucherid) => {


        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        setIsLoading2(true);
        // Correct path: companies/{company_uid}/vouchers
        const productQuery = query(
            collection(db, servicetablename, select_company_uid, "vouchers"),
            where("voucherid", "==", voucherid),
            where("status", "==", true)
        );
        const unsubscribe = onSnapshot(
            productQuery,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                const v = vouchers[0] || {};
                setVouchersdata(v);
                setVoucherid(v.voucherid);
                setAmount(v.amount);
                setTotalamount(v.voucherid);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("uid");

        if (uid) {

            // setIsedit(true);
            fetchvouchers(uid);
        } else {
            // setIsedit(false);
        }
    }, [window.location.search]);



    /* 🔹 LIVE PAYMENT STATUS */
    useEffect(() => {
        if (!select_company_uid) return;

        const q = query(
            collection(db, "companies", select_company_uid, "payment_setting")
        );

        const unsub = onSnapshot(q, (snap) => {
            if (!snap.empty) {
                setPaymentstatus(!!snap.docs[0].data().paymentstatus);
            }
        });

        return unsub;
    }, [select_company_uid]);


    useEffect(() => {
        if (!select_company_uid || !guid || !printpage) return;

        const applyQuery = query(
            collection(
                db,
                servicetablename,
                select_company_uid,
                "print_settings_account_apply"
            ),
            where("guid", "==", guid),
            where("status", "==", true),
            where("printpage", "==", printpage)
        );

        const unsubscribe = onSnapshot(
            applyQuery,
            (snapshot) => {
                if (snapshot.empty) {
                    setPrintapply(null);
                    return;
                }
                setPrintapply(snapshot.docs[0]?.data()?.printsize ?? null);
                setPrintid(snapshot.docs[0]?.data()?.printid ?? null);
            },
            (error) => {
                console.error("Print apply listener error:", error);
                setPrintapply(null);
            }
        );

        return unsubscribe;
    }, [select_company_uid, guid, printpage]);


    useEffect(() => {
        const fetchledger_accounts = async () => {

            if (!voucherid) return;

            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            setIsLoading2(true);

            const managerQ = query(
                collection(db, servicetablename, select_company_uid, "ledger_accounts_manager"),
                where("voucherid", "==", voucherid),
                where("ledger_type", "==", "charges"),
                orderBy("indexnumber", "asc")
            );

            const unsubscribe = onSnapshot(
                managerQ,
                async (managerSnap) => {
                    try {
                        if (managerSnap.empty) {
                            setManage_ledger_accountsdata([]);
                            setIsLoading2(false);
                            return;
                        }

                        const managerList = managerSnap.docs.map(d => ({
                            id: d.id,
                            ...d.data(),
                        }));

                        const accountguids = managerList
                            .map(m => m.accountguid)
                            .filter(Boolean);

                        if (accountguids.length === 0) {
                            setManage_ledger_accountsdata([]);
                            setIsLoading2(false);
                            return;
                        }

                        const accountsQuery = query(
                            collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                            where("accountguid", "in", accountguids)
                        );

                        const accountsSnap = await getDocs(accountsQuery);

                        if (accountsSnap.empty) {
                            setManage_ledger_accountsdata([]);
                            setIsLoading2(false);
                            return;
                        }

                        const ledgerList = accountsSnap.docs.map(d => ({
                            id: d.id,
                            ...d.data(),
                        }));

                        // --- MERGE DATA ---
                        const finalData = managerList.map(manager => {
                            const ledger = ledgerList.find(
                                l => l.accountguid === manager.accountguid
                            );


                            return {
                                ...ledger,
                                ...manager, // contains indexnumber
                            };
                        });

                        // --- SORT AGAIN BY indexnumber (safe) ---
                        finalData.sort((a, b) => (a.indexnumber || 0) - (b.indexnumber || 0));

                        setManage_ledger_accountsdata(finalData);

                        setIsLoading2(false);

                    } catch (err) {
                        console.error("Error:", err);
                        setIsLoading2(false);
                    }
                },
                (error) => {
                    console.error("Error fetching ledger data:", error);
                    setIsLoading2(false);
                }
            );

            return () => unsubscribe();
        };

        fetchledger_accounts();
    }, [vouchersdata]);

    const handlevoucher_print = async () => {

        setDoPrint(false);
        if (saveloading == true) {
            return
        }
        if (!namepaying || !namepaying.trim()) {
            Toastshow("Please enter name");
            return;
        }
        if (!mobile || !mobile.trim()) {
            Toastshow("Please enter mobile");
            return;
        }
        if (!voucherid || !voucherid.trim()) {
            Toastshow("Please enter voucherid");
            return;
        }
        if (!voucherprintid || !voucherprintid.trim()) {
            Toastshow("Please enter voucherprintid");
            return;
        }

        if (!amount || Number(amount) == 0) {
            Toastshow("Please enter amount");
            return;
        }
        if (!totalamount || Number(totalamount) == 0) {
            Toastshow("Please enter total amount");
            return;
        }
        let status = false;
        if (payment_method_online == false) {
            status = true;
        }
        setSaveloading(true);

        const eventdateObj = new Date(eventdate);
        const payload = {
            voucher: vouchersdata.voucher,
            description: vouchersdata.description,
            remarks,
            voucherid,
            filemanager,
            mobilestatus,
            voucherprintid,
            vouchernumber,
            refer_number,
            eventdate: Timestamp.fromDate(eventdateObj),
            voucher_type: vouchersdata.voucher_type,
            code,
            status,
            stockstatus,
            receiptstatus: true,
            eventstatus,
            mobile,
            accountnumber: mobile,
            payment_method_online,
            namepaying,
            addresspaying,
            amount: Number(amount) || 0,
            totalamount: Number(totalamount) || 0
        };

        const result = await Save_voucher_print(payload);
        if (result.success) {
            if (voucher_file_stock_qty_data.length > 0) {
                save_voucher_print_stock(vouchernumber, voucherprintid);
            } else {
               
                if (print === true) {
                    setDoPrint(true); // trigger printing
                    new_print();
                } else {
                    new_print();
                }
                Toastshow("Voucher saved successfully.");
            }
        } else {
            setSaveloading(false);
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    const new_print = async () => {
        const timer = setTimeout(() => {
            setvouchernumber(Randomnumber(10));
            setVoucherprintid(Randomcode(13));
            setVoucherdate(new Date().toLocaleString());
            setEventdate(false);
            setSaveloading(false);
            setMobile("");
            setNamepaying("");
            setAddresspaying("");
        }, 2000);

    }
    // useEffect(() => {
    //     if (!doPrint) return;

    //     const timer = setTimeout(() => {
    //         window.print();
    //         setDoPrint(false);
    //     }, 500); // wait for DOM render

    //     return () => clearTimeout(timer);
    // }, [doPrint]);


    const fetchCompanies = async () => {

        try {
            const q = query(
                collection(db, "companies"),
                where("companyuid", "==", Cookies.get("select_company_uid")),

            );

            const snapshot = await getDocs(q);

            if (snapshot.empty) {
                console.log("No companies found");
                setCompanyData([]);
                return;
            }
            const docs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();

                    // fetch child collection "fields"
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    let child = {};
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        child[fieldName] = fieldValue;
                    });

                    const fullData = { uid: docSnap.id, ...docData, child };

                    return fullData;
                })
            );
            //  setIsLoading_banner(false);
            // setOld_file_uid(docs[0]?.logo_uid || "null"); // set old_file_uid state
            setBannerUrl(docs[0]?.banner_url || banner_default); // set BannerUrl state with a default placeholder if none
            setOld_banner_file_uid(docs[0]?.banner_uid || "null"); // set old_banner_file_uid state
            setLogoUrl(docs[0]?.logo_url || logo_default); // set logoUrl state with a default placeholder if none
            setCompanyData(docs); // update state

        } catch (err) {
            console.error("Error fetching companies:", err);
        } finally {

        }
    };
    const fetch_voucher_stock = async () => {
        if (!voucherid) return; // avoid query before UID exists

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        setIsLoading2(true);


        // Correct path: companies/{company_uid}/vouchers
        const Query = query(
            collection(db, servicetablename, select_company_uid, "voucher_file_manager"),
            where("file_type", "==", "stock"),
            where("voucherid", "==", voucherid)
        );

        const unsubscribe = onSnapshot(
            Query,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                setVoucher_file_stock_qty_data(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };
    const fetch_voucher_file_manager = async () => {
        if (!voucherid) return; // avoid query before UID exists

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;
        setIsLoading2(true);


        // Correct path: companies/{company_uid}/vouchers
        const Query = query(
            collection(db, servicetablename, select_company_uid, "voucher_file_manager"),
            where("file_type", "==", "uploadfile"),
            where("voucherid", "==", voucherid)
        );

        const unsubscribe = onSnapshot(
            Query,
            (snapshot) => {
                const vouchers = snapshot.docs.map((docSnap) => ({
                    id: docSnap.id,
                    ...docSnap.data(),
                }));

                setVoucher_file_manager_data(vouchers);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching vouchers:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };
    useEffect(() => {
        fetch_voucher_stock();
        fetchCompanies();
        fetch_voucher_file_manager();
    }, [voucherid, voucherprintid]);

    useEffect(() => {
        // guard
        if (!manage_ledger_accountsdata || manage_ledger_accountsdata.length === 0) {
            setChargetotal(0);

            setTotalamount(Number(amount || 0));
            return;
        }

        const initial = Number(amount || 0);
        let running = initial;
        let totalCharge = 0;

        // Apply each rule one-by-one in array order
        for (const row of manage_ledger_accountsdata) {
            const op = row?.manageacalc;        // "+" or "-"
            const mode = row?.mathedcalc;       // "%" or "="
            const val = Number(row?.amount ?? 0);

            if (mode === "%") {
                // percentage applied to current running amount
                let delta = (running * val) / 100;
                if (op === "-") delta = -delta;
                running += delta;
                totalCharge += delta;
            } else {
                // "=" treat as flat add/subtract
                let delta = val;
                if (op === "-") delta = -delta;
                running += delta;
                totalCharge += delta;
            }
        }

        // Round for state but keep numeric type
        const fixedCharge = Number(totalCharge.toFixed(2));
        const fixedTotal = Number(running.toFixed(2));

        setChargetotal(fixedCharge);
        setTotalamount(fixedTotal);
    }, [manage_ledger_accountsdata, amount]);
    //

    useEffect(() => {
        setEventdate(new Date().toISOString().slice(0, 16));
    }, []);
    //qty add

    const [items, setItems] = useState(voucher_file_stock_qty_data);
    useEffect(() => {
        setItems(voucher_file_stock_qty_data);
    }, [voucher_file_stock_qty_data]);

    const handleQtyChange = (id, value) => {
        let v = value.replace(/[^0-9.]/g, "");
        const parts = v.split(".");
        if (parts.length > 2) v = parts[0] + "." + parts.slice(1).join("");

        setItems(prev =>
            prev.map(item =>
                item.id === id
                    ? {
                        ...item,
                        qty: v,
                        amount: parseFloat(v || 0) * parseFloat(item.price || 0)
                    }
                    : item
            )
        );
    };
    useEffect(() => {
        const total = items.reduce(
            (sum, item) => sum + Number(item.amount || 0),
            0
        );
        if (total > 0) {
            setstockstatus(true);
        } else {
            setstockstatus(false);
        }
        if (total > 0) {
            setAmount(total);
        }

    }, [items]);
    //save
    const save_voucher_print_stock = async (vouchernumber, voucherprintid) => {
        if (!items.length) {
            setIsLoading(false);

            if (print === true) {
                setDoPrint(true); // trigger printing
                new_print();
            } else {
                new_print();
            }

            Toastshow("Voucher saved successfully.");
            return;
        }

        const cleanItems = items
            .filter(i => Number(i.qty) > 0)
            .map(i => ({
                item_id: i.id,
                title: i.title,
                itemname: i.itemname,
                price: Number(i.price),
                qty: Number(i.qty),
                amount: Number(i.amount),
                perday: i.perday === true
            }));

        if (!cleanItems.length) {

            return;
        }

        try {

            const savequery = {
                voucherid: voucherid,
                voucherprintid,
                companyuid: select_company_uid,
                items: cleanItems,
                total_amount: amount,
                vouchernumber,
                status: true,
                guid: guid,
                date_time: new Date(),
            }
            const parentDocRef = doc(
                db,
                "accountingfinancedb",
                select_company_uid,
                "voucher_print_stock",
                voucherprintid
            );
            await setDoc(parentDocRef, savequery);
            setIsLoading(false);
            if (print === true) {
                setDoPrint(true); // trigger printing
                new_print();
            } else {
                new_print();
            }

            Toastshow("Voucher saved successfully.");
        } catch (err) {
            console.error(err);
            Toastshow("Save failed");
        }
    };


    return (
        <div className="voucher-body">
            <div className="photo-pso-div "
            >
                <img
                    src={vouchersdata.logo_url || logo_default}
                    alt={vouchersdata.voucher}
                    className="pos_logo_url"
                />
                <div className="name-div ">

                    <table>
                        <tr>
                            <td className="text-h1 bold fcap shadow">{vouchersdata.voucher}</td>
                        </tr>
                        <tr>
                            <td className="text-h3 bold fcap shadow">{vouchersdata.description}</td>
                        </tr>
                        <tr className="text-h1 bold fcap">{vouchersdata.voucher_type}</tr>
                    </table>
                </div>

            </div>
            <div className="items-back-fill-dark">

                <table >
                    <tbody>
                        <tr>
                            <td>
                                <td  >
                                    <div className="button-ui0 bold text-h2"><MdOutlineReceiptLong className="icon" />#{vouchernumber}</div> </td>

                            </td>

                            <td width={190} className="text-r">
                                <div className="button-ui0 text-h2 bold "><MdCalendarMonth className="icon" />{voucherdate}</div>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {/* Contact details */}
            <div className="items-back b-bottom p-11">
                <table  >
                    <tr>
                        <td width={25}><MdCall className="icon" /></td>
                        <td>
                            <CountryCodeSelect value={code} onChange={setCode} />
                        </td>


                        <td width={25}><MdOutlineAccountBox className="icon" /></td>
                        <td>
                            <input
                                type="text"
                                maxLength={60}
                                value={namepaying}
                                onChange={(e) => setNamepaying(e.target.value)}
                                className="text-h2 bold items-back-fill border-none"
                                placeholder="Name"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td width={25}>
                            <Select_yes_no
                                checked={mobilestatus}
                                onChange={() => setMobilestatus(!mobilestatus)}
                            />
                        </td>
                        <td width={130}>
                            <input
                                type="tel"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                maxLength={10}
                                className="text-h1 bold items-back-fill border-none  items-back"
                                placeholder="Mobile number"
                            />
                        </td>
                        <td width={25}><MdOutlineLocationOn className="icon" /></td>
                        <td>
                            <input
                                maxLength={300}

                                value={addresspaying}
                                onChange={(e) => setAddresspaying(e.target.value)}
                                className="text-h2 items-back-fill border-none"
                                placeholder="Enter Address"
                            />
                        </td>
                    </tr>
                </table>
            </div>
            {/* voucher_file_manager */}
            {voucher_file_manager_data.length > 0 && (

                <div className="ui-grid-fill b-bottom ">
                    {IsLoading2 ? (
                        null
                    ) : voucher_file_manager_data.length === 0 ? (
                        <div></div>
                    ) : (
                        <div >
                            {voucher_file_manager_data.map((row) => (
                                <div key={row.id} className="ui-items p-11">
                                    <table >
                                        <tbody >
                                            <tr>

                                                <td>
                                                    <table>
                                                        {row?.filenumber === true && (
                                                            <tr>
                                                                <td className="text-off text-h3 fcap">
                                                                    {row.title}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        maxLength={100}
                                                                        className="fcap border-none text-h2 items-back-fill"
                                                                        placeholder={`Enter ${row?.fileshortname || "N/A"} Number`}
                                                                        value={filemanager[row.id]?.filenumber || ""}
                                                                        onChange={(e) =>
                                                                            handleRowChange(row.title, row.id, "filenumber", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td><div className="button-ui2 cursor"
                                                                    onClick={() => {
                                                                        const v = filemanager[row.id]?.filenumber;

                                                                        if (v && v.length > 2) {
                                                                            setuploadfiledata({
                                                                                filenumber: v,
                                                                                row
                                                                            });
                                                                            set_uploadfile();
                                                                        } else {
                                                                            Toastshow("Enter Number");
                                                                        }
                                                                    }}>

                                                                    <MdOutlineAddAPhoto className="icon" /></div></td>
                                                            </tr>
                                                        )}
                                                        {row?.issue_date === true && (
                                                            <tr>
                                                                <td className="text-off text-h3">
                                                                    Issue Date
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="date"
                                                                        className="border-none text-h3 items-back-fill"
                                                                        value={filemanager[row.id]?.issue_date || ""}
                                                                        onChange={(e) =>
                                                                            handleRowChange(row.title, row.id, "issue_date", e.target.value)
                                                                        }
                                                                    />
                                                                </td>

                                                            </tr>
                                                        )}
                                                        {row?.expiry_date === true && (
                                                            <tr>
                                                                <td className="text-off text-h3">
                                                                    Expiry Date
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="date"
                                                                        className="border-none text-h3 items-back-fill"
                                                                        value={filemanager[row.id]?.expiry_date || ""}
                                                                        onChange={(e) =>
                                                                            handleRowChange(row.title, row.id, "expiry_date", e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                            </tr>
                                                        )}

                                                    </table>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="text-h5 text-off fcap p-1">
                                        {row.description || "No account found"}
                                    </div>
                                </div>
                            ))}

                        </div>
                    )}
                </div>
            )}
            <div className="ui-grid-fill">
                {IsLoading2 ? (
                    null
                ) : voucher_file_stock_qty_data.length === 0 ? (
                    <div></div>
                ) : (
                    <div>
                        {items.map((row) => (
                            <div key={row.id} className="ui-items b-bottom p-11">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="text-h3 fcap">
                                                    {row.title || "No name"}{" "}
                                                    <a className="text-off text-h3">
                                                        {row.itemname || "No item"}
                                                    </a>
                                                </div>
                                            </td>

                                            <td>
                                                <div className="text-h3 text-r flex">
                                                    {row.perday ? "Per Day" : "Price"}:
                                                    <a className="bold text-h2"> {row.price}</a>/-
                                                </div>
                                            </td>

                                            <td width={70}>
                                                <input
                                                    type="number"
                                                    maxLength={10}
                                                    className="border-none text-h1 items-back-fill"
                                                    placeholder="Qty"
                                                    value={row.qty || ""}
                                                    onChange={(e) =>
                                                        handleQtyChange(row.id, e.target.value)
                                                    }
                                                />
                                            </td>

                                            <td width={80}>
                                                <div className="text-h2 bold text-r p-1">
                                                    {row.amount || "0.00"}/-
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>

                )}
            </div>

            {/* Amount */}
            <div className="items-back  p-22 p-top">
                <table>
                    <tbody>
                        <tr>
                            <td>

                                <div className="items-back ">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <div className="text-h2 bold fcap">{vouchersdata.voucher}</div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div className="text-h3 fcap">{vouchersdata.description}</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div></td>
                            <td width={150} className="text-r text-h1">
                                {vouchersdata.editable == true ? (
                                    <table>
                                        <tr>
                                            <b width={20}><div className="text-off line-hight-35 text-h1">₹</div></b>
                                            <td> <input
                                                type="number"
                                                maxLength={10}
                                                className=" bold text-h1  border-none items-back-fill"

                                                placeholder="Amount"
                                                value={amount}
                                                onChange={(e) => {
                                                    let v = e.target.value.replace(/[^0-9.]/g, "");
                                                    const parts = v.split(".");
                                                    if (parts.length > 2) v = parts[0] + "." + parts.slice(1).join("");
                                                    setAmount(v);
                                                    setTotalamount(v);
                                                }}

                                            /></td>
                                        </tr>
                                    </table>


                                ) : (

                                    <div className="text-h1 cap bold text-r">₹{vouchersdata.amount}/-</div>
                                )}

                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="ui-grid-fill">
                    {IsLoading2 ? (
                        null
                    ) : manage_ledger_accountsdata.length === 0 ? (
                        <div></div>
                    ) : (
                        <div >
                            {manage_ledger_accountsdata.map((row) => (

                                <div key={row.id} className="ui-items">

                                    <table >
                                        <tbody >
                                            <tr>
                                                <table>
                                                    <tr> <td>

                                                        <div className="text-h2 bold fcap">
                                                            {row.name || "No account found"}
                                                        </div>
                                                    </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='text-h4 text-off'>
                                                            Apply: {row.date_time?.toDate ? (
                                                                <>
                                                                    {row.date_time.toDate().toLocaleDateString()}{" "}
                                                                    {row.date_time.toDate().toLocaleTimeString()}
                                                                </>
                                                            ) : (
                                                                <div className='contact-details'>No date</div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                </table>
                                                <td width={150} >
                                                    <table>
                                                        <tr>
                                                            <td >
                                                                <div className="text-h2 bold text-r">


                                                                    {" "}{row?.amount || "--"}{" "}

                                                                    {row?.mathedcalc === "=" ? ("") : (row?.mathedcalc)}
                                                                </div>
                                                            </td>

                                                        </tr>

                                                    </table>
                                                </td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            ))}

                        </div>
                    )}

                </div>

            </div>
            {/* Total */}
            <div className="items-back ">
                <table>
                    <tbody>
                        {chargetotal > 0 && (
                            <tr className="b-top p-11">
                                <td><div className="text-h3 fcap  ">Charges</div></td>
                                <td className="text-r">

                                    <span className="text-h3   text-r cap">₹{Number(chargetotal).toFixed(2)}/-</span>

                                </td>
                            </tr>
                        )}

                        <tr className="items-back-fill-dark">
                            <td><div className="text-h1 p-11 fcap bold">Total payable</div></td>
                            <td width={24} ><MdCalculate onClick={() => setCalculateopen(true)} className="icon cursor" /></td>
                            <td width={130} className="text-r p-11">
                                <span className="text-h1 bold text-r cap">₹{Number(totalamount).toFixed(2)}/-</span>
                            </td>

                        </tr>
                    </tbody>
                </table>
                <div className="p-1 text-h3">
                    <AmountToWords amount={totalamount} />
                </div>

            </div>

            {/* Agree */}
            <div className="items-back">
                <div className="ui-items p-22">
                    <table>
                        <tr>
                            {eventstatus ? (
                                <td><div className="bold text-h2">Event date</div></td>
                            ) : ("")}
                            <td>
                                {eventstatus === true ? (
                                    <div
                                        className="text-h2 m-bottom flex"
                                        onClick={() => document.getElementById("my_date").showPicker()}
                                        style={{ cursor: "pointer" }}
                                    >

                                        <input
                                            id="my_date"
                                            type="datetime-local"
                                            className="text-h2 bold border-none items-back-fill"
                                            value={eventdate}
                                            onChange={(e) => setEventdate(e.target.value)}
                                            min={new Date().toISOString().slice(0, 16)}
                                        />


                                    </div>
                                ) : (<div className="bold text-h2">Event</div>)}
                            </td>
                            <td width={30}>
                                <Select_yes_no
                                    checked={eventstatus}
                                    onChange={() => setEventstatus(!eventstatus)}
                                />
                            </td>
                        </tr>
                    </table>

                    <input className="bold text-h2 border-none items-back-fill" onChange={(e) => setRefer_number(e.target.value)} placeholder="Ref Number option"></input>
                    <textarea className="m-top border-none items-back-fill" row={7} maxLength={200} onChange={(e) => setRemarks(e.target.value)} rows={2} placeholder="Remark" />
                </div>
                <div className="ui-items ">

                    {paymentstatus == true && (
                        <table  >
                            <tr>
                                <td>
                                    <div
                                        onClick={() => setPayment_method_online(false)}
                                        className={`fill p-2 cursor ${payment_method_online === false ? "button-ui red-back" : "button-ui2"}`}
                                    >
                                        <MdOutlinePayments className="icon" />
                                        Payment Cash
                                    </div>
                                </td>
                                <td>
                                    <div
                                        onClick={() => setPayment_method_online(true)}
                                        className={`fill p-2 cursor ${payment_method_online ? "button-ui red-back" : "button-ui2"
                                            }`}
                                    >
                                        <MdOutlinePayment className="icon" />
                                        Payment Online
                                    </div>
                                </td>
                            </tr>
                        </table>
                    )}
                </div>
                <div className="ui-items p-22">
                    <table className="table-fixed">
                        <tr>
                            <td>
                                <div className="button-ui2 fill">

                                    <div className="button-ui0 p-1 cursor"
                                        onClick={() => {
                                            setSettingprintopen(true);
                                        }}
                                    >
                                        <MdOutlineLocalPrintshop className="icon cursor" /><div className="bold">{printapply}</div>
                                    </div>
                                    <Select_on_off checked={print} onChange={(e) => { setPrint(!print) }} />
                                </div>
                            </td>
                            <td>
                                <div className="items-back">
                                    <table>
                                        <tr>
                                            {print === true ? (
                                                <td>
                                                    {saveloading == true ? (
                                                        <div
                                                            className="button-ui fill green-back text-h1 p-2 cursor"
                                                        >
                                                            <Loadingimg width={30} />
                                                        </div>
                                                    ) : (<div
                                                        className="button-ui fill text-h1 p-2 cursor green-back"
                                                        onClick={handlevoucher_print}
                                                    >
                                                        <MdPrint className="icon" /> Print
                                                    </div>)}

                                                </td>

                                            ) : (
                                                <td>
                                                    {saveloading == true ? (
                                                        <div
                                                            className="button-ui fill text-h1 p-2 cursor"
                                                        >
                                                            <Loadingimg width={30} />
                                                        </div>
                                                    ) : (<div
                                                        className="button-ui fill text-h1 p-2 cursor"
                                                        onClick={handlevoucher_print}
                                                    >
                                                        <MdSaveAs className="icon" />
                                                        Save
                                                    </div>)}

                                                </td>
                                            )}
                                        </tr>
                                    </table>
                                </div>

                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <Calculatepopup
                data={totalamount || 0}
                isOpen={calculateopen}
                onClose={() => setCalculateopen(false)} />
            {voucherprintid && doPrint && printapply === "4INCH" && (
                <Print_receipt_order voucherprintid={voucherprintid} printid={printid} />
            )}
            {voucherprintid && doPrint && printapply === "A4" && (
                <Print_receipt_a4 voucherprintid={voucherprintid} printid={printid} />
            )}
            <Settingprint_popup data={printpage} isOpen={settingprintopen} onClose={() => setSettingprintopen(false)} />

            <Upload_file_popup
                data={uploadfiledata}
                isOpen={uploadfileopen}
                onClose={() => setuploadfileopen(false)} />


        </div>

    );
}
